



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { User } from '@/core/admin/models/User';
import DialogTitle from '@/ui/components/atoms/textItems/DialogTitle.vue';
import { AlertStoreActions, AlertType } from '@/ui/stores/AlertStore';
import { AdminStoreMutations } from '@/ui/stores/AdminStore';
import ButtonWithText from '@/ui/components/atoms/buttons/ButtonWithText.vue';
import { CmsCredentialToCreateDTO } from '@/core/admin/DTO/CmsCredentialsDTO';
import CmsCredentialsForm from '@/ui/components/organisms/forms/CmsCredentialsForm.vue';
import { CmsCredentialData } from '@/core/admin/models/CmsCredential';
import { UpdateCmsCredentialsDTO } from '@/core/admin/DTO/UpdateCmsCredentialsDTO';
import { createCmsCredentialUseCase, updateCmsCredentialsUseCase } from '@/core/admin/usecases/cmsCredentialUseCases';

@Component({
  name: 'CmsCredentialDialog',
  components: { CmsCredentialsForm, ButtonWithText, DialogTitle },
})
export default class NewUserDialog extends Vue {
  @Prop() userId!: string;
  @Prop({ default: null }) cmsCredential: CmsCredentialData | undefined;
  @Prop({ type: Boolean }) showDialog!: boolean;
  @Prop({ type: Boolean }) isNewCmsCredential!: boolean;
  @Prop({ type: Boolean }) isEditCmsCredential!: boolean;
  private triggerSaveNewOnForm = false;
  private triggerSaveUpdateOnForm = false;
  private isLoading = false;

  mounted() {
    this.$store.dispatch('adminStore/getAllCustomersWithoutCmsCredential');
  }

  get currentUser(): User {
    return this.$store.state.userStore.currentUser;
  }

  async createCmsCredentialValidInput(cmsCredentialsToCreate: CmsCredentialToCreateDTO) {
    this.isLoading = true;
    createCmsCredentialUseCase(this.currentUser, cmsCredentialsToCreate)
      .then(() => {
        this.closeDialog();
        this.$store.commit(AdminStoreMutations.SET_IS_NEW_CMS_CREDENTIALS_CREATED, true);
        this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
          message: 'Admin.cms-credentials.create-success',
          type: AlertType.SUCCESS,
        });
        this.$emit('created');
      })
      .catch(() => {
        this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
          message: 'Admin.create-user.error-message',
          type: AlertType.ERROR,
        });
        this.$store.dispatch('adminStore/getAllCustomersWithoutCmsCredential');
      })
      .finally(() => {
        this.triggerSaveNewOnForm = false;
        this.isLoading = false;
      });
  }

  async updateCmsCredentialValidInput(cmsCredentialsToUpdate: UpdateCmsCredentialsDTO) {
    this.isLoading = true;
    updateCmsCredentialsUseCase(this.currentUser, cmsCredentialsToUpdate)
      .then(() => {
        this.closeDialog();
        this.$store.commit(AdminStoreMutations.SET_IS_NEW_CMS_CREDENTIALS_CREATED, true);
        this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
          message: 'Admin.edit-user.success-alert',
          type: AlertType.SUCCESS,
        });
      })
      .catch(() => {
        this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
          message: 'Admin.edit-user.error-alert',
          type: AlertType.ERROR,
        });
      })
      .finally(() => {
        this.triggerSaveUpdateOnForm = false;
        this.isLoading = false;
      });
  }

  handleInvalidInput() {
    this.triggerSaveNewOnForm = false;
    this.triggerSaveUpdateOnForm = false;
  }

  closeDialog() {
    this.$emit('close');
    this.clearInput();
  }

  clearInput() {
    const ref = this.$refs.cmsCredentialsForm as CmsCredentialsForm;
    ref.clearInput();
  }

  createCmsCredential() {
    this.triggerSaveNewOnForm = true;
  }

  updateCmsCredential() {
    this.triggerSaveUpdateOnForm = true;
  }
}
